import { ProblemDetailsSchema } from '@minutes-system/backend/src/http/problemDetails';
import { HttpError } from '../../shared/httpError';

export interface ErrorView {
  status?: number;
  message?: string;
}

const buildErrorView = (error: unknown): ErrorView => {
  if (error instanceof HttpError) {
    const problem = ProblemDetailsSchema.safeParse(error.body);
    return {
      status: error.status,
      message: problem.success ? problem.data.detail : undefined,
    };
  }
  if (error instanceof Error) {
    return { message: error.message };
  }
  return { message: 'Unknown error' };
};

export default buildErrorView;
